import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { EmpresaStatus } from 'src/app/core/models/onboarding/EmpresaStatus';
import { OnboardingService } from 'src/app/core/services/onboarding';

@Component({
  selector: 'app-onboarding-empresa',
  templateUrl: './onboarding-empresa.component.html',
  styleUrls: ['./onboarding-empresa.component.scss'],
})
export class OnboardingEmpresaComponent implements OnInit {
  @Output() next = new EventEmitter();

  onboardingService = inject(OnboardingService);

  empresaStatus!: EmpresaStatus;

  ngOnInit(): void {
    this.loadOnboardingStatus();
  }

  onNextClick(): void {
    this.next.emit();
  }

  private loadOnboardingStatus(): void {
    this.onboardingService.getEmpresaStatus().subscribe((empresaStatus) => {
      this.empresaStatus = empresaStatus;
    });
  }
}
